<div class="detailSnackbar">
  <h4>{{ title }}:</h4>

  <li *ngFor="let item of moreInfo">{{ item }}</li>
</div>

